export default __webpack_public_path__ + "static/media/plane-seat12.6956ad88.svg";